/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { withTheme } from "@material-ui/core/styles";
import styled from "styled-components";

import StyledTextField from "../common/StyledTextField";
import types from "../../helpers/types";

const StyledAutoComplete = styled(Autocomplete)`
  .MuiAutocomplete-input {
    color: ${(props) => props.theme.palette.primary.dark};
  }
`;

const ProblemCodeAutoComplete = ({
  theme,
  error,
  handleChange,
  autocompleteTestId,
  value,
}) => {
  const problemCode = types.problemCodes.find(
    (problemCode) => problemCode.id === value
  );

  return (
    <StyledAutoComplete
      onChange={handleChange}
      options={types.problemCodes}
      getOptionLabel={(option) =>
        `${option.description} ${option.code ? `(${option.code})` : ""}`
      }
      disableClearable={true}
      value={problemCode}
      data-testid={autocompleteTestId}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Problem"
          variant="outlined"
          error={error}
        />
      )}
      ListboxProps={{
        style: { maxHeight: "500px" },
      }}
      theme={theme}
    />
  );
};

export default withTheme(ProblemCodeAutoComplete);
